import { MissionIsPreBilledMessage } from '../../../missions/mission-messages'

import React from 'react'
import { MissionWeekIsValidatedMessage } from '../../../missions/mission-messages'
import { createColumns } from '../utils'
import { getWeek, getWeekYear } from '../../../../utils/date'
import { ColumnGroupDefinition } from '../types'
import { CostCell } from '../table-cells'

interface WeekStateColumnGroupProps {
  start: Date
  minimalMode?: boolean
}

const weekStateColumnGroup = ({
  start,
  minimalMode,
}: WeekStateColumnGroupProps): ColumnGroupDefinition => ({
  Header: `Semaine`,
  id: 'week',
  className: 'sticky has-background-white',
  columns: createColumns([
    {
      header: '€/h',
      id: 'week.rate',
      shouldMerge: true,
      isHidden: minimalMode,
      className: 'sticky',
      render: ({ totals, mission }) => (
        <CostCell
          cost={totals.costs.hourly}
          noCostAvailable={mission.contractModel === 'twoParties'}
        />
      ),
    },
    {
      header: (
        <MissionWeekIsValidatedMessage
          mission={{ weekIsValidated: true }}
          type="icon"
          small
          iconColor="dark"
        />
      ),
      id: 'week.validation',
      className: 'sticky',
      shouldMerge: true,
      render: ({ weekIsValidated }) => (
        <MissionWeekIsValidatedMessage
          mission={{ weekIsValidated: weekIsValidated }}
          type="icon"
          small
        />
      ),
    },
    {
      header: <MissionIsPreBilledMessage force type="icon" iconColor="dark" small />,
      id: 'week.preBilled',
      className: 'sticky table-section-end-2x',
      shouldMerge: true,
      render: ({ mission }) => (
        <MissionIsPreBilledMessage
          mission={mission}
          type="icon"
          small
          week={getWeek(start)}
          year={getWeekYear(start as Date)}
        />
      ),
    },
  ]),
})

export default weekStateColumnGroup
